import { IAddress } from '../address';
import { create, validate, active, searchActive, IOrgUpdate, IOrgAI, IAIUpdate, IAIUpdateRequest, IRequestMeta } from './updateRequest';

export class OrgServiceFactory {
  updateRequest = {
    create,
    validate,
    active,
    searchActive
  };
}

export type { IOrgAI, IOrgUpdate, IAIUpdate, IAIUpdateRequest, IRequestMeta };

export interface IOrgAddress extends IAddress {
  addrId: string;
  addrTypeCd: string;
  jobFunctionCd: string;
}

export interface IOrgPhone {
  jobFunctionCd: string;
  orgPhoneTypeCd: string;
  phoneCc: string;
  phoneNdc: string;
  phoneLocal: string;
}

export interface IOrgUrl {
  urlTypeCd: string;
  urlAddr: string;
}

export interface IOrg {
  orgId: string;
  orgName: string;
  visitingAddress: IOrgAddress;
  shippingAddress?: IOrgAddress;
  website: string;
  phone?: IOrgPhone;
  email?: string;
  orgSubTypeCd: string;
  fax?: IOrgPhone;
}
